module.exports = __webpack_public_path__ + "images/b513e6b95770031171fb4498871fa4d8.png";